import React from "react";
import { useLocation } from "react-router";
import qs from "qs";

export const FacultyLeaveContext = React.createContext();

export const FacultyLeaveProvider = ({ children }) => {
  const location = useLocation();

  const [facultyLeaveFiltersPreference, setFacultyLeaveFiltersPreference] =
    React.useState(initialFacultyLeaveFiltersState(location));

  const [pagination, setPagination] = React.useState({
    page: 0,
  });

  return (
    <FacultyLeaveContext.Provider
      value={{
        facultyLeaveFiltersPreference,
        setFacultyLeaveFiltersPreference,
        pagination,
        setPagination,
      }}
    >
      {children}
    </FacultyLeaveContext.Provider>
  );
};

export const initialFacultyLeaveFiltersState = (location) => {
  const params = qs.parse(location.search);

  return {
    universityId: params.universityId || "",
    department: params.department || "",
    division: params.division || "",
    line: params.line || "",
    status: params.status || "Active",
    apptType: params.apptType || "SAB,PDL",
  };
};

export const useFacultyLeaveContext = () => {
  return React.useContext(FacultyLeaveContext);
};
